export default __webpack_public_path__ + "static/media/ubelens-logo-color.3a74d922.png";